/**
 * Marker embedded in `SubtreeErrorBoundary`'s console line so `Sentry.init`'s `beforeSend`
 * can recognise — and drop — the duplicate event `captureConsoleIntegration` builds out of
 * it. Shared as a constant rather than duplicated as a literal at both ends, because a
 * silent drift would quietly restore the double-reporting with nothing failing.
 *
 * THIS MODULE MUST STAY DEPENDENCY-FREE. It is imported by `src/index.tsx`, and anything
 * reachable from the entry module is evaluated before `Sentry.init` runs — so pulling in a
 * component or a store from here changes the order in which the app's module graph
 * initialises. That is not hypothetical: putting this constant on the boundary component
 * itself and importing that into `index.tsx` dragged MUI, toastmaster and `@stores/Tracking`
 * forward in the graph and tripped a pre-existing circular import between `@stores/User` and
 * `@stores/Billing` — `BillingStore`'s constructor reaction read `userStore` in its temporal
 * dead zone and the app failed to boot.
 *
 * Hence a leaf module holding one string, rather than the more natural-looking home next to
 * the code that logs it. Keep it that way, and keep it importing nothing.
 */
export const ERROR_BOUNDARY_CONSOLE_MARKER = 'error boundary caught an error:';
